// extracted by mini-css-extract-plugin
export var orderSummary = "_tm-0";
export var showMoreLessButton = "_tm-1";